import React, { FC, useState } from 'react';
import { useGetProgramMasterData } from 'src/api/mutations/useGetProgramMasterData';
import './IncreaseStrengthSteps.scss';
import { ReactComponent as Low_impact_training_onlyIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/low_impact_training_only.svg';
import { ReactComponent as Return_to_movementIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/return_to_movement.svg';
import { ReactComponent as Return_to_strengthIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/return_to_strength.svg';
import { ReactComponent as Return_to_sportIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/return_to_sport.svg';

interface RehabilitationStep2Props {
  value?: string;
  onNext?: (value: string) => void;
}

const iconMap: Record<string, React.ReactNode> = {
  return_to_movement: <Return_to_movementIcon />,
  return_to_strength: <Return_to_strengthIcon />,
  return_to_sport: <Return_to_sportIcon />,
  low_impact_training_only: <Low_impact_training_onlyIcon />,
};

// What stage is the client working toward?
export const RehabilitationStep2: FC<RehabilitationStep2Props> = ({ value, onNext }) => {
  const [selectedStage, setSelectedStage] = useState<string>(value || '');
  const { data: programMasterData, isLoading, isError } = useGetProgramMasterData();

  const stageData = programMasterData?.rehabilitationStage;

  const stages = stageData?.options
    ? [...stageData.options].sort((a: any, b: any) => a.order - b.order)
    : [];

  if (isLoading) {
    return <div className="increase-strength-step">{'Loading options...'}</div>;
  }

  if (isError || !stageData) {
    return <div className="increase-strength-step">{'Error loading options.'}</div>;
  }

  return (
    <div className="increase-strength-step">
      <h2 className="step-title">{stageData?.title}</h2>
      {/*<p className="step-subtitle">{stageData?.subtitle}</p>*/}

      <div className="goal-buttons">
        {stages.map((stage: any) => (
          <button
            key={stage.id}
            className={`goal-btn ${selectedStage === stage.slug ? 'selected' : ''}`}
            onClick={() => {
              setSelectedStage(stage.slug);
              if (onNext) onNext(stage.slug);
            }}
          >
            <div className="goal-icon">{iconMap[stage.id]}</div>
            <span className="goal-label">{stage.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
